import { useLocation } from "react-router-dom";

export const useQueryParams = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  return {
    get: key => searchParams.get(key),
  };
};
